// SessionNumber — the session's ordinal as a small square: "7" for session 7.
//
// ONE component for every place a session list shows its number, couple and therapist
// alike (CompletedSessionsTable, SessionRow, CoupleSessionRow). Those three used to
// spell the square out inline and had already drifted: SessionRow set 12px medium,
// the table 14px semibold, and the couple row was a 32px sage disc. Sage is the
// interactive family, and a number you cannot tap should not wear it.
//
// 40px, --radius-md, hairline --border on --canvas: the ground token, one step off the
// --surface row it sits in, so it reads as a quiet recess rather than a status fill.
// Decorative by default (aria-hidden): every row that shows it also names the session
// in text or in its accessible label.

export interface SessionNumberProps {
    n: number;
    className?: string;
}

export function SessionNumber({ n, className = "" }: SessionNumberProps) {
    return (
        <span
            aria-hidden="true"
            className={[
                "flex h-10 w-10 shrink-0 items-center justify-center rounded-[var(--radius-md)] border border-border bg-canvas [font:var(--type-label)] text-secondary",
                className,
            ]
                .filter(Boolean)
                .join(" ")}
        >
            {n}
        </span>
    );
}
